goog.provide("shadow.js.shim.module$src$svg$objects$clock_dashed_quarter_svg$default");
shadow.js.shim.module$src$svg$objects$clock_dashed_quarter_svg$default = shadow.js.shim.module$src$svg$objects$clock_dashed_quarter_svg.default;
